/**
 * Calcule la capacité effective (places occupées) d'une réservation
 * en tenant compte du mode de comptage des enfants.
 * 
 * @param numberOfPeople - Nombre d'adultes
 * @param numberOfChildren - Nombre d'enfants (additionnel)
 * @param capacityMode - Mode de comptage : 'full' | 'half' | 'none'
 * @returns Nombre de places effectivement occupées
 */
export function calculateEffectiveCapacity(
  numberOfPeople: number,
  numberOfChildren: number,
  capacityMode: 'full' | 'half' | 'none'
): number {
  switch (capacityMode) {
    case 'full':
      return numberOfPeople + numberOfChildren;
    case 'half':
      return numberOfPeople + Math.ceil(numberOfChildren / 2);
    case 'none':
      return numberOfPeople;
    default:
      return numberOfPeople + numberOfChildren;
  }
}

/**
 * Calcule la capacité effective lorsque le nombre fourni par le formulaire
 * inclut déjà les enfants.
 */
export function calculateEffectiveCapacityFromTotal(
  totalPeople: number,
  numberOfChildren: number,
  capacityMode: 'full' | 'half' | 'none'
): number {
  const safeChildren = Math.max(0, Math.min(numberOfChildren, totalPeople));
  const adultCount = Math.max(0, totalPeople - safeChildren);
  return calculateEffectiveCapacity(adultCount, safeChildren, capacityMode);
}

/**
 * Nombre total maximal affichable pour une capacité physique donnée lorsque
 * le total du formulaire inclut déjà les enfants.
 */
export function calculateMaxTotalForCapacity(
  rawCapacity: number,
  numberOfChildren: number,
  capacityMode: 'full' | 'half' | 'none'
): number {
  const safeChildren = Math.max(0, numberOfChildren);
  switch (capacityMode) {
    case 'full':
      return rawCapacity;
    case 'half':
      return rawCapacity + Math.floor(safeChildren / 2);
    case 'none':
      return rawCapacity + safeChildren;
    default:
      return rawCapacity;
  }
}
